import { cn } from "@/libs/utils";
import { ReactNode, useEffect, useMemo, useRef, useState } from "react";
import { Subtitle4 } from "@/components/webview/games/typograpy/typograpy-webview";

export enum GameTabsWebview {
  Home = "Home",
  MetaQuest = "Meta Quest",
  SteamVR = "Steam VR",
  Pico = "Pico",
  PSVR2 = "PSVR2",
  SimRacing = "Sim Racing",
  PCGame = "PC Game",
  AudioToHaptic = "Audio-to-Haptics",
}

interface GameTabsViewProps {
  tabItems: { label: GameTabsWebview }[];
  activeList: ReactNode[];
}

const GamesTabMenuWebView = ({ tabItems, activeList }: GameTabsViewProps) => {
  const [activeTab, setActiveTab] = useState<GameTabsWebview>(
    GameTabsWebview.Home,
  );

  const tabIndexMap = useMemo(
    () => Object.fromEntries(tabItems.map((item, i) => [item.label, i])),
    [tabItems],
  );
  // console.log("tabIndexMap:", tabIndexMap);

  const handleTabChange = (label: GameTabsWebview) => {
    setActiveTab(label);

    //tab click 시 최상위로 이동
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const handler = (e: CustomEvent) => {
      const tabLabel = e.detail as GameTabsWebview;
      setActiveTab(tabLabel);

      const index = tabItems.findIndex((item) => item.label === tabLabel);
      if (index !== -1 && tabRangeRefs.current[index]) {
        tabRangeRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }
    };
    window.addEventListener("changeTab", handler as EventListener);
    return () =>
      window.removeEventListener("changeTab", handler as EventListener);
  }, []);

  const tabRangeRefs = useRef<(HTMLLIElement | null)[]>([]);

  //mobile 에서 gnb 처리하기위한 영역을 만듭니다
  const MOBILE_GNB_HEIGHT = "top-12";

  return (
    <>
      <div>
        {/*webview gnb 고려 top-12 에서부터 sticky*/}
        <section
          id="tab-content-section"
          className={cn("z-10 bg-black pb-4 pt-2", MOBILE_GNB_HEIGHT)}
        >
          <div className="relative">
            <div className="scrollbar-none overflow-x-auto">
              <ul className="relative flex min-w-full list-none gap-[6px] px-4 max:px-0">
                {tabItems.map((item, index) => (
                  <li
                    key={item.label}
                    ref={(el) => {
                      tabRangeRefs.current[index] = el;
                    }}
                    className={cn(
                      "flex h-[34px] items-center whitespace-nowrap rounded-full border border-[#3F3F3F] px-3 py-1 font-400",
                      activeTab === item.label
                        ? "border-white bg-white text-black"
                        : "hover:text-coolgray-70",
                    )}
                  >
                    <button
                      onClick={() => {
                        handleTabChange(item.label);

                        //tab 클릭시 화면 중앙 정렬
                        tabRangeRefs.current[index]?.scrollIntoView({
                          behavior: "smooth",
                          block: "nearest",
                          inline: "center",
                        });
                      }}
                    >
                      <Subtitle4>{item.label}</Subtitle4>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div className="pointer-events-none absolute right-0 top-0 h-[34px] w-10 bg-gradient-to-l from-black/80 to-transparent" />
          </div>
        </section>

        {/*render 될 activeList*/}
      </div>
      <div>{activeList[tabIndexMap[activeTab]]}</div>
    </>
  );
};

export default GamesTabMenuWebView;
